import { FetchUserContactDetails, UpdateUserContactDetails } from '../api/dto/UserContactDetails';
import { FetchUserCompanyDetails, UpdateUserCompanyDetails } from '../api/dto/UserCompanyDetails';

const EMAIL_REGEX =
  "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?";

const URL_REGEX = '^((https?|ftp|smtp):\\/\\/)?(www.)?[a-z0-9.-]+\\.[a-z]+(\\/[a-zA-Z0-9#]+\\/?)*\\/?$';

const isValidUserContactDetailsMandatoryFields = (payload: FetchUserContactDetails | UpdateUserContactDetails) => {
  return Boolean(
    (payload?.salutation === 'MALE' || payload?.salutation === 'FEMALE' || payload?.salutation === 'COMPANY') &&
      payload.firstName &&
      payload.lastName &&
      payload.phoneNumber,
  );
};

const isValidUserCompanyDetailsMandatoryFields = (payload: FetchUserCompanyDetails | UpdateUserCompanyDetails) => {
  return Boolean(
    payload?.name &&
      payload.email &&
      payload.phoneNumber &&
      payload.url &&
      payload.city &&
      payload.street &&
      payload.houseNumber &&
      payload.zipCode &&
      payload.country,
  );
};

const isValidEmailPattern = (value?: string): boolean => value?.toLowerCase().match(EMAIL_REGEX) !== null;

const isValidURLPattern = (value?: string): boolean => value?.toLowerCase().match(URL_REGEX) !== null;

export const sharedValidators = {
  isValidUserContactDetailsMandatoryFields: isValidUserContactDetailsMandatoryFields,
  isValidUserCompanyDetailsMandatoryFields: isValidUserCompanyDetailsMandatoryFields,
  isValidEmailPattern: isValidEmailPattern,
  isValidURLPattern: isValidURLPattern,
};
